<template>
  <div>
    <div class="graph-title">
      <h4>图谱分析</h4>
      <div style="width: 100%" v-if="CrossCommunity.nodes && CrossCommunity.nodes.length > 0">
        <echarts-graph
          ref="graphs"
          :width="805"
          :height="600"
          :graphData="sortedCommunityData"
        ></echarts-graph>
      </div>
      <div v-else>
        <el-empty description="暂无图谱数据"></el-empty>
      </div>
    </div>
    <div class="graph-title">
      <h4>相关实体</h4>
      <el-tabs v-model="activeTabsName" @tab-click="handleClick">
        <el-tab-pane label="时间" name="EVENT TIME"></el-tab-pane>
        <el-tab-pane label="人物" name="PERSON"></el-tab-pane>
        <el-tab-pane label="组织" name="ORGANIZATION"></el-tab-pane>
        <el-tab-pane label="地域" name="GEO"></el-tab-pane>
      </el-tabs>

      <!-- :data="CrossCommunity.nodes" -->

      <el-table
        :data="filteredNodes"
        align="center"
        stripe
        :header-cell-style="{
          'text-align': 'center',
          background: 'var(--brand)',
          color: '#fff'
        }"
      >
        <el-table-column prop="id" label="实体名称" width="200" align="center">
        </el-table-column>
        <el-table-column prop="description" label="概述"> </el-table-column>
      </el-table>
    </div>

    <!-- <div class="graph-title">
      <h4>事件脉络</h4>
      <el-table
        :data="filteredTimeNodes"
        align="center"
        stripe
        :header-cell-style="{
          'text-align': 'center',
          background: 'var(--brand)',
          color: '#fff'
        }"
      >
      {{ filteredTimeNodes }}
        <el-table-column prop="id" label="事件时间" width="200">
        </el-table-column>
        <el-table-column prop="description" label="事件描述"> </el-table-column>
      </el-table>
    </div> -->
  </div>
</template>

<script>
import EchartsGraph from "@/pages/views/project/components/EchartsGraph.vue";

export default {
  props: {
    CrossCommunity: {
      type: Object
    }
  },
  components: {
    EchartsGraph
  },
  data() {
    return {
      activeTabsName: "EVENT TIME" // 默认选中“人物”标签
    };
  },
  activated() {},
  watch: {},
  computed: {
    sortedCommunityData() {
      const nodesMap = new Map(
        this.CrossCommunity.nodes.map((node) => [node.id, node])
      );

      this.CrossCommunity.links.forEach((link) => {
        if (nodesMap.has(link.source)) {
          link.color = nodesMap.get(link.source).color;
        }
      });
      return {
        nodes: this.CrossCommunity.nodes,
        links: this.CrossCommunity.links
      };
    },

    filteredNodes() {
      if (this.CrossCommunity && this.CrossCommunity.nodes) {
        // 过滤出符合条件的节点
        const nodes = this.CrossCommunity.nodes.filter(
          (node) => node.type === this.activeTabsName
        );
        // 对节点进行排序，将 id 为 "习近平" 或 "习近平书记" 的节点排在最前面
        return nodes.sort((a, b) => {
          const isALiMing = a.id === "习近平" || a.id === "习近平总书记";
          const isBLiMing = b.id === "习近平" || b.id === "习近平总书记";

          if (isALiMing && !isBLiMing) return -1;
          if (!isALiMing && isBLiMing) return 1;
          return 0;
        });
      }
      
    },
    filteredTimeNodes() {
      return this.CrossCommunity.nodes.filter(
        (node) => node.type === "EVENT TIME"
      );
    }
  },
  created() {},
  mounted() {},
  methods: {
    handleClick(tab) {
      this.activeTabsName = tab.name;
    }
  }
};
</script>

<style lang="scss" scoped>
.graph-title {
  margin-bottom: 60px;
  h4 {
    color: var(--text-1);
    margin-bottom: 15px;
    position: relative;
    text-indent: 10px;
    font-size: 16px;
    font-weight: bold;
    &::before {
      content: "";
      width: 3px;
      height: 16px;
      background-color: var(--text-2);
      position: absolute;
      top: 50%;
      left: 0;
      transform: translateY(-50%);
    }
  }
}
</style>
